import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* LIBRARIES */
import * as React from 'react';
import classNames from 'classnames';
import { isEmpty, pathEq, pathOr, path, pick } from 'ramda';
import { debounce } from 'throttle-debounce';
/* MODULES */

import { Slave } from './slave';
import { getMasterStylesClasses } from './helpers';
import { DEFAULT_SLAVE_COORDS, getSlaveCoordsAndPosition, getElementCoords } from './coords';
/* STYLES */

import * as stylesModule from './tooltip.css';
/* TYPES */

/* CONSTANTS */
import { DEFAULT_MOUSE_TIMEOUT } from '../constants';
export var HANDLERS_ARRAY = [// Mouse events
'onOpen', 'onClose', // Mouse events
'onMouseDown', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', // Mouse events
'onTouchEnd', 'onTouchStart'];
/* CONSTANTS */

export var TOOLTIP_CUSTOM_TYPE = {
  click: 'click',
  hover: 'hover'
};
export var TOOLTIP_CUSTOM_POSITION = {
  top: 'top',
  right: 'right',
  left: 'left',
  bottom: 'bottom'
};
/* TYPES */

export * from './types';
export var Tooltip =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Tooltip, _React$PureComponent);

  // tslint:disable-next-line:no-any
  function Tooltip(_props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "timer", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      if (props.onClick) {
        props.onClick(event);
      }

      if (pathEq(['custom', 'type'], 'click', props)) {
        _this.timer = window.setTimeout(_this.openSlave, 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openSlave", function () {
      if (!_this.state.isOpen && _this.state.masterRef.current && _this.state.slaveRef.current) {
        var _getSlaveCoordsAndPos = getSlaveCoordsAndPosition({
          masterCoords: getElementCoords(_this.state.masterRef.current),
          slaveCoords: getElementCoords(_this.state.slaveRef.current.divRef.current),
          pos: _this.state.position,
          alignedOnEdge: Boolean(path(['custom', 'alignedOnEdge'], _this.props))
        }),
            slaveCoords = _getSlaveCoordsAndPos.coords,
            position = _getSlaveCoordsAndPos.position;

        if (_this.props.onOpen) {
          _this.props.onOpen();
        }

        _this.setState({
          isOpen: true,
          slaveCoords: slaveCoords,
          position: position
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isHover", function (props) {
      return !props.custom || !props.custom.type || !pathEq(['custom', 'type'], 'click', props);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (event) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          _assertThisInitialize3 = _assertThisInitialize2.props,
          onMouseEnter = _assertThisInitialize3.onMouseEnter,
          _assertThisInitialize4 = _assertThisInitialize3.__attributes,
          __attributes = _assertThisInitialize4 === void 0 ? {} : _assertThisInitialize4;

      if (onMouseEnter) {
        onMouseEnter(event);
      }

      if (__attributes.onMouseEnter) {
        __attributes.onMouseEnter(event);
      }

      if (_this.isHover(_this.props)) {
        _this.timer = window.setTimeout(_this.openSlave, 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (event) {
      var _assertThisInitialize5 = _assertThisInitialized(_this),
          _assertThisInitialize6 = _assertThisInitialize5.props,
          onMouseLeave = _assertThisInitialize6.onMouseLeave,
          _assertThisInitialize7 = _assertThisInitialize6.__attributes,
          __attributes = _assertThisInitialize7 === void 0 ? {} : _assertThisInitialize7;

      if (onMouseLeave) {
        onMouseLeave(event);
      }

      if (__attributes.onMouseLeave) {
        __attributes.onMouseLeave(event);
      }

      if (_this.isHover(_this.props)) {
        _this.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var _assertThisInitialize8 = _assertThisInitialized(_this),
          props = _assertThisInitialize8.props,
          state = _assertThisInitialize8.state;

      if (state.isOpen) {
        if (props.onClose) {
          props.onClose();
        }

        if (pathEq(['custom', 'type'], 'click', props)) {
          _this.setState({
            isOpen: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      if (_this.state.isOpen && pathEq(['custom', 'type'], 'click', _this.props) && (pathEq(['custom', 'mediaType'], 'desktop', _this.props) || pathEq(['custom', 'mediaType'], 'adaptive', _this.props) || window.matchMedia('(min-width: 741px)'))) {
        _this.handleClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickDebounce", debounce(DEFAULT_MOUSE_TIMEOUT, _this.handleClick));

    _defineProperty(_assertThisInitialized(_this), "handleScrollDebounce", debounce(DEFAULT_MOUSE_TIMEOUT, true, _this.handleScroll));

    _this.state = {
      isOpen: false,
      position: pathOr('bottom', ['custom', 'position'], _props),
      slaveCoords: DEFAULT_SLAVE_COORDS,
      masterRef: React.createRef(),
      slaveRef: React.createRef()
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /* istanbul ignore next line */
      if (this.state.masterRef.current && this.state.slaveRef.current) {
        var _getSlaveCoordsAndPos2 = getSlaveCoordsAndPosition({
          masterCoords: getElementCoords(this.state.masterRef.current),
          slaveCoords: getElementCoords(this.state.slaveRef.current.divRef.current),
          pos: this.state.position,
          alignedOnEdge: !!(this.props.custom && this.props.custom.alignedOnEdge)
        }),
            slaveCoords = _getSlaveCoordsAndPos2.coords,
            position = _getSlaveCoordsAndPos2.position;

        document.addEventListener('scroll', this.handleScrollDebounce, false);
        this.setState({
          slaveCoords: slaveCoords,
          position: position
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.handleScrollDebounce, false);
      window.clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$__attribu = _this$props.__attributes,
          __attributes = _this$props$__attribu === void 0 ? {} : _this$props$__attribu,
          children = _this$props.children,
          _this$props$dataMark = _this$props.dataMark,
          dataMark = _this$props$dataMark === void 0 ? 'TooltipMaster' : _this$props$dataMark,
          _this$props$__classNa = _this$props.__classNames,
          __classNames = _this$props$__classNa === void 0 ? '' : _this$props$__classNa,
          master = _this$props.master,
          _this$props$styles = _this$props.styles,
          styles = _this$props$styles === void 0 ? {} : _this$props$styles,
          _this$props$custom = _this$props.custom,
          custom = _this$props$custom === void 0 ? {} : _this$props$custom;

      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          slaveCoords = _this$state.slaveCoords,
          position = _this$state.position;
      var handlers = pick(HANDLERS_ARRAY, this.props);
      return React.createElement("div", _extends({
        "data-mark": dataMark,
        className: classNames(stylesModule['master'], _defineProperty({}, getMasterStylesClasses(styles), !isEmpty(styles)), __classNames)
      }, __attributes, handlers, {
        onClick: this.handleClickDebounce,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        ref: this.state.masterRef
      }), master, React.createElement(Slave, {
        isOpen: isOpen,
        styles: styles,
        custom: custom,
        isHover: this.isHover(this.props),
        onOutside: this.handleClose,
        "data-mark": "TooltipMaster",
        coords: slaveCoords,
        position: position,
        ref: this.state.slaveRef
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var pos = pathOr('bottom', ['custom', 'position'], props);
      /* istanbul ignore next line */

      if (state.masterRef.current && state.slaveRef.current) {
        var _getSlaveCoordsAndPos3 = getSlaveCoordsAndPosition({
          masterCoords: getElementCoords(state.masterRef.current),
          slaveCoords: getElementCoords(state.slaveRef.current.divRef.current),
          pos: pos === state.position ? state.position : pos,
          alignedOnEdge: Boolean(path(['custom', 'alignedOnEdge'], props))
        }),
            slaveCoords = _getSlaveCoordsAndPos3.coords,
            position = _getSlaveCoordsAndPos3.position;

        return {
          slaveCoords: slaveCoords,
          position: position
        };
      }
      /* istanbul ignore next line */


      return null;
    }
  }]);

  return Tooltip;
}(React.PureComponent);